import React from "react";
import { useNavigate } from "react-router-dom";
import { createBrandLogo } from "adminApi/BrandListApi/BrandList";
import { validateForm } from "utils/validation";
import { BrandLogoRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddBrandLogoForm from "./Componates/AddBrandLogoForm";
import fields from "../json/BrandLogoListFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { getImageUrl } from "utils/imageHelper";

const AddBrandLogo = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize default form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange } = useFormChange(
    initialValues,
    BrandLogoRules
  );

  const { loading, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        formData.append(key, val ?? "");
      });
      return await createBrandLogo({ data: formData });
    },
    (vals) => validateForm(vals, BrandLogoRules),
    () => navigate(-1),
    "Brand Logo Created successfully"
  );


  return (
    <>
      {loading && <Spinner isSpinner={true} />}
      <AddBrandLogoForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        imagePreview={values.brand_logoPreview || getImageUrl(values.brand_logo)}
        loading={loading}
      />
    </>
  );
};

export default AddBrandLogo;
